import {injectable} from "inversify";
import TeamFieldBasedCurrency from "@/modules/action-points/services/TeamFieldBasedCurrency";
import {GateTypeEnum} from "@/modules/action-points/enums";

@injectable()
export default class CoinsActionPointsCurrency extends TeamFieldBasedCurrency {
  protected getFieldName(): 'actionPointsCoins' {
    return 'actionPointsCoins';
  }

  protected getType(): GateTypeEnum {
    return GateTypeEnum.COINS;
  }
}
